module.exports = __webpack_public_path__ + "img/lg_ring_r_o_0_0@2x.075a3e46.png";